import { writeSettingsFields } from './settings-fields';

/** `PATCH /client/settings/fields`: `settings.can_create_trip`. */
export const editTripCreateFromApp = async (can_create_trip: object): Promise<any> =>
  writeSettingsFields({ can_create_trip });
